module.exports = __webpack_public_path__ + "static/media/message_form_background.e3bb2662.jpg";